export const account = {
    dashboard: {
        editEmailAddress: 'E-Mail Adresse bearbeiten',
        editAdress: 'Kundendaten bearbeiten',
        changePassword: 'Passwort ändern',
    },
    backToDashboard: 'Zurück',
    accountView: {
        customerData: 'Kundendaten',
        customer: 'Kunde',
    },
    editEmailAddressForm: {
        header: 'Wie lautet Ihre aktuelle E-Mail Addresse?',
        backToStart: 'Zurück zur Startseite',
        labels: {
            email: 'E-Mail',
            submit: 'E-Mail ändern',
        },
        messages: {
            confirmationSent:
                'Um Ihre neue E-Mail Adresse zu bestätigen haben wir eine E-Mail an Sie versendet. Bitte überprüfen Sie Ihr postfach.',
            anErrorHasOccured:
                ' Hier scheint ein Fehler aufgetreten zu sein. Bitte bitte prüfen Sie ihre Mails oder versuchen Sie es zu einem späteren Zeitpunkt erneut.',
            emailChangedSuccessful:
                'Ihre E-Mail Adresse wurde erfolgreich geändert.',
            confirmationLinkInvalid:
                'Ihre E-Mail Adresse konnte nicht geändert werden. Der Bestätigungslink ist ungültig oder bereits abgelaufen. Bitte versuchen Sie es erneut.',
        },
    },
    changePasswordForm: {
        header: 'Passwort ändern',
        chooseNewPassword: 'Bitte legen Sie Ihr neues Passwort fest.',
        labels: {
            submit: 'Passwort ändern',
        },
        messages: {
            passwordChangePending: 'Wird geändert...',
            passwordChangedSuccessful: 'Ihr Passwort wurde geändert.',
        },
        hints: {
            atLeastNCharacters:
                'Keine Mindestlänge. | Mindestens ein Zeichen. | Mindestens {n} Zeichen.',
            passwordsDontMatch: 'Passwörter Stimmen nicht überein.',
        },
    },
    resetPasswordForm: {
        header: 'Setzen Sie Ihr Passwort zurück',
        chooseNewPassword: 'Bitte legen Sie ein neues Passwort fest',
        labels: {
            newPassword: 'Neues Passwort',
            repeatPassword: 'Passwort wiederholen',
            submit: 'Passwort zurücksetzen',
            password: 'Passwort',
        },
        messages: {
            resetEmailSent:
                'Wenn ein Konto zu dieser E-Mail Adresse existiert, wurde ein Link zum Zurücksetzen Ihres Passworts an Sie versendet.',
            passwordResetPending: 'Wird geändert...',
            passwordResetSuccessful: 'Ihr Passwort wurde geändert',
            passwordResetBlocked:
                'Ein Link zum Zurücksetzen Ihres Passworts wurde bereits versendet. Sie können nur alle 24 Stunden einen neuen Link anfordern.',
            genericError:
                'Hier ist ein Fehler aufgetreten. Eventuell ist der verwendete Nutzername nicht korrekt. Bitte überprüfen Sie Ihre Eingabe auf Tippfehler oder versuchen Sie es später noch einmal.',
            resetLinkInvalid:
                'Hier scheint ein Fehler aufgetreten zu sein. Der Link zum Zurücksetzen Ihres Passworts wurde bereits benutzt oder ist abgelaufen.',
        },
        hints: {
            atLeastNCharacters:
                'Keine Mindestlänge. | Mindestens ein Zeichen. | Mindestens {n} Zeichen.',
            passwordsDontMatch: 'Passwörter Stimmen nicht überein.',
        },
    },
};
